// gameStateService.ts
import { HubConnection } from '@microsoft/signalr';
import { normalizeShipDto, normalizeShipPurchaseOption } from '../types/ship-types';
import type { GameStateDto } from '../types/gameState';

export async function getGameState(connection: HubConnection, playerId: string): Promise<GameStateDto> {
  const data = await connection.invoke('GetGameState', playerId);

  if (Array.isArray(data.fleet)) {
    data.fleet = data.fleet.map(normalizeShipDto);
  }
  if (Array.isArray(data.shipPurchaseOptions)) {
    data.shipPurchaseOptions = data.shipPurchaseOptions.map(normalizeShipPurchaseOption);
  }
  if (Array.isArray(data.ShipPurchaseOptions)) {
    data.ShipPurchaseOptions = data.ShipPurchaseOptions.map(normalizeShipPurchaseOption);
  }
  return data;
}

export async function setPlayerName(connection: HubConnection, playerId: string, name: string) {
  return await connection.invoke('SetPlayerName', playerId, name);
}